import { Injectable } from '@angular/core'
import { StaticMenuItem } from '@ftr/menus'
import { AppPaths } from '@ftr/routing-paths'

/**
 * Contains navigation items that are used by global admin users.
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalNavItems {
  logout(): StaticMenuItem {
    return {
      title: 'Log out',
      path: [`/${AppPaths.Logout}`],
    }
  }
}
